import { isLoading, Loading } from "../loading";
import { useAllTaskTypes } from "./useTaskTypes";
import { useRemoveMediaArticlesAfterComplete } from "./useRemoveMediaArticlesAfterComplete";
import { Task } from "../types/Task";
import { useQueryClient } from "@tanstack/react-query";
import { resetVotesAfterComplete } from "./useResetVotesAfterComplete";
import { useRedirect } from "./useRedirect";

export const useAfterComplete = (
  task: Record<string, unknown> | undefined | Loading
): (() => void) => {
  const queryClient = useQueryClient();
  const { data: taskTypes, isLoading: isTaskTypesLoading } = useAllTaskTypes();
  const redirect = useRedirect();
  const removeMediaArticlesMutation = useRemoveMediaArticlesAfterComplete();

  const afterComplete = taskTypes?.find(
    (type) => type.id === (task as Task)?.task_type_id
  )?.after_complete;

  if (
    isLoading(task) ||
    isTaskTypesLoading ||
    !afterComplete ||
    task === undefined
  ) {
    return () => {};
  }

  const executeAfterComplete = async () => {
    const { id, props } = afterComplete;

    switch (id) {
      case "redirect":
        redirect(props.url, props.openNewTab);
        return;
      case "reset-votes":
        resetVotesAfterComplete(task, props, queryClient);
        return;
      case "remove-media-articles":
        await removeMediaArticlesMutation.mutateAsync({ task, props });
        return;
      default:
        return;
    }
  };

  return executeAfterComplete;
};
